import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TabPanel from 'components/TabPanel';
import {
  Grid,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  Box,
} from '@material-ui/core';
import MenuControls from './MenuControls';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '700px'
  },
  selectRoot: {
    '&:hover': {
      color: theme.palette.primary.main,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.accent.main
      }
    }
  },
  selectInput: {
    padding: '10px'
  },
  defaultFieldInput: {
    padding: '5px',
    color: theme.palette.grey.dark,
    border: `1px solid ${theme.palette.grey.medium}`,
    borderRadius: '4px',
    marginBottom: '8px',
    '&:before': {
      display: 'none'
    },
    '&:after': {
      display: 'none'
    }
  }
}));

const FiltersTab = ({ handleClose, value, widgetOverlayLists, setFilters }) => {
  const classes = useStyles();

  const initialValues = {};
  if (widgetOverlayLists && widgetOverlayLists.length > 0) {
    widgetOverlayLists.forEach(overlayListItem => {
    if (overlayListItem.widgetFiltersList.filtersListMembers && overlayListItem.widgetFiltersList.filtersListMembers.length > 0) {
      const initialMember = overlayListItem.widgetFiltersList.filtersListMembers[0];
      initialValues[overlayListItem.widgetFiltersList.name] = initialMember.memberText;
    }
  });

  Object.keys(initialValues).forEach(key => {
    initialValues[key] = "all";
  });
}
  
  const [values, setValues] = useState(initialValues);

  const handleSelectChange = (listName, memberText) => {
    setValues(prevValues => ({
      ...prevValues,
      [listName]: memberText
    }));
  };

  const handleSave = () => {
    const selectedLists = Object.entries(values)
      .filter(([listName, memberText]) => memberText !== 'all')
      .map(([listName, memberText]) => ({ listName, memberText }));
    setFilters(selectedLists);
    handleClose();
  };

  return (
    <TabPanel value={value} index={3} style={{ minWidth: '700px' }}>
      <Box style={{marginLeft: '10px', marginBottom: '15px'}}>
        {widgetOverlayLists && widgetOverlayLists.length > 0 && widgetOverlayLists.map((overlayListItem, index) => {
          return (
            <Grid item xs={12} md={7} key={overlayListItem.id}>
              <h3>{overlayListItem.widgetFiltersList.text}</h3>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor={`object-type-select-${index}`}>Item(s)...</InputLabel>
                <Select
                  native
                  value={values[overlayListItem.widgetFiltersList.name] || 'all'} // Set default value to 'all'
                  label="Choose..."
                  inputProps={{ id: 'object-type-select' }}
                  className={classes.selectRoot}
                  classes={{ select: classes.selectInput }}
                  onChange={(event) =>
                    handleSelectChange(overlayListItem.widgetFiltersList.name, event.target.value)
                  }
                >
                  <option key="all" value="all">
                    All
                  </option>
                  {overlayListItem.widgetFiltersList.filtersListMembers && overlayListItem.widgetFiltersList.filtersListMembers.length > 0 && overlayListItem.widgetFiltersList.filtersListMembers.map(m => (
                    <option key={m.id} value={m.memberText}>
                      {m.memberText}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )
        })}
      </Box>
       <MenuControls handleClose={handleClose} useFormSubmit={false} onSubmit={handleSave} />
    </TabPanel>
  );
};

FiltersTab.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

export default FiltersTab;
